import css from 'styled-jsx/css';

const styles = css.global`.confirmation .text-title {
  color: #222;
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 40px;
  line-height: 60px;
  letter-spacing: 0px;
  margin: 0 0 8px;
}

.confirmation .text-subtitle {
  color: #444;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  max-width: 654px;
}

.confirmation .custom-acc-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
}

.confirmation .custom-acc-head img {
  max-width: 24px;
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0;
  padding: 0;
}

.confirmation .custom-acc-head p {
  margin: 0;
  padding: 0;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #222;
}

.confirmation .data-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #cccccc;
}

.confirmation .data-grid .data-key,
.confirmation .data-grid .data-value {
  text-align: left;
  color: #222;
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  margin: 0;
  padding: 0;
}

.confirmation .data-grid .data-value {
  text-align: right;
  font-weight: 700;
}

.confirmation .accordion {
  margin-top: 16px;
}

.confirmation .data-grid.total {
  padding: 56px 0;

  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;

  margin: 16px 0 24px;
  grid-template-columns: 0.5fr 1.5fr;
}

.confirmation .data-grid.total .data-key,
.confirmation .data-grid.total .data-value {
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.confirmation .data-grid.total .data-value {
  justify-content: flex-end;
  font-family: 'SantanderText';
  font-weight: 700;
  font-style: Bold;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
}

.confirmation .btns-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.confirmation .data-grid.data-grid-last {
  padding-bottom: 0;
  border-bottom: none;
}

.confirmation #confimation-item-1 .acc-body .data-grid p:first-of-type {
  font-weight: bold;
}

@media (min-width: 992px) {
  .confirmation .accordion {
    margin-top: 32px;
  }

  .confirmation .btns-wrapper {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
  }

  .confirmation .btns-wrapper .sn-button.white {
    max-width: 140px;
  }

  .confirmation .btns-wrapper .sn-button.red {
    max-width: 228px;
  }
}
`;

export default styles;